module.exports = __webpack_public_path__ + "img/img58.a5491d74.svg";